import * as basicLightbox from 'basiclightbox';
import { setupForm } from './forms';

const html = document.querySelector('html');

export default(() => {
    const popups = Array.from(document.querySelectorAll('.js-popup'));

    // Get cookie
    function getCookie(name) {
        const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
        return v ? v[2] : null;
    }
    popups.forEach((popup) => {
        const popupInstance = basicLightbox.create(popup, {
            onShow: (instance) => {
                const popupForm = instance.element().querySelector('form');
                if (popupForm) {
                    setupForm(popupForm);
                }

                // Detect if vue data attr present
                const hasVue = instance.element().querySelector('[data-vue]');
                if (hasVue) window[hasVue.dataset.vue].$mount(hasVue);

                html.classList.add('scroll-lock');

                document.addEventListener('close-popups', () => instance.close());
                const closeTriggers = Array.from(instance.element().querySelectorAll(`.js-popup-close-${popup.id}`));
                closeTriggers.forEach(elem => elem.addEventListener('click', (e) => {
                    e.preventDefault();
                    instance.close();
                }));
                // Display Date cookie declaration (for id card)
                if (popup.classList.contains('js-cookie-date')) {
                    const cookieDate = instance.element().querySelector('.js-cookie-date');
                    if (getCookie('date')) {
                        const dateValue = getCookie('date');
                        cookieDate.innerHTML = `Last opened: ${dateValue}`;
                    } else {
                        const date = new Date();
                        const options = {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        };
                        cookieDate.innerHTML = `Last opened: ${date.toLocaleTimeString('en-us', options)}`;
                    }
                }
            },
            onClose: (instance) => {
                html.classList.remove('scroll-lock');
                // Create Date cookie declaration (for id card)
                if (popup.classList.contains('js-cookie-date')) {
                    const cookieDate = instance.element().querySelector('.js-cookie-date');
                    if (cookieDate) {
                        const date = new Date();
                        const options = {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                        };
                        document.cookie = `date=${date.toLocaleTimeString('en-us', options)}; expires=Thu, 18 Dec 2030 12:00:00 UTC`;
                        console.log(date.toLocaleTimeString('en-us', options)); // eslint-disable-line no-console
                    }
                }
            },

            closable: !popup.classList.contains('js-keep-open')
        });

        const openTriggers = Array.from(document.querySelectorAll(`.js-popup-open-${popup.id}`));
        openTriggers.forEach(elem => elem.addEventListener('click', (e) => {
            e.preventDefault();
            popupInstance.show();
        }));

        if (popup.classList.contains('js-popup-secondary')) {
            document.addEventListener('open-secondary-popups', () => popupInstance.show());
        } else {
            document.addEventListener('open-popups', () => popupInstance.show());
        }

        if (popup.classList.contains('js-popup-open-onload')) popupInstance.show();
    });
})();
